import styled from 'styled-components';
import type { FieldArrayWithId } from 'react-hook-form';

import { UltraSelect } from 'components/UltraSelect';
import { productPriceRangeSource } from 'data/entity-sources/sources';
import { RangePrice } from './TTCPrices';
import { PriceRangeType } from 'data/__generated__';

type PriceRangeFiels = FieldArrayWithId<
    {
        rangePrices: RangePrice[];
    },
    'rangePrices',
    'id'
>[];

export const PriceRangeSelector = ({
    append,
    fields,
}: {
    append: (
        value:
            | { rangeId: string; price: number; crossedPrice?: number; type: PriceRangeType }
            | { rangeId: string; price: number; crossedPrice?: number; type: PriceRangeType }[],
    ) => void;
    fields: PriceRangeFiels;
}) => {
    const onSelect = (value: string | null) => {
        if (value && !fields.some(({ rangeId }) => rangeId === value)) {
            append({ rangeId: value, price: 0, crossedPrice: undefined, type: PriceRangeType.Product });
        }
    };

    return (
        <SelectorContainer>
            <UltraSelect
                source={productPriceRangeSource}
                dataTest="select-product"
                label="Ajouter à une gamme de prix "
                placeholder="Sélectionner une gamme (recherche par nom ou par _id)"
                value={null}
                onChange={onSelect}
            />
        </SelectorContainer>
    );
};

const SelectorContainer = styled.div`
    width: 100%;
    font-size: 15px;
`;
